const toolbarHashtag = {
    options: [
      "colorPicker",
    ],
    colorPicker: {
      icon: '',
      className: 'toolbar-item change-color',
        component: undefined,
        popupClassName: undefined,
        colors: ["#000000", "#ffffff", "#ff0000", "#00ff00", "#0000ff", "#ffff00", "#00ffff", "#ff00ff", "#808080", "#800000", "#808000", "#008000", "#800080", "#008080", "#000080"],
      },
  };
  
  export default toolbarHashtag;
  